import { prototype } from "events";
import { pipeline } from "stream";

export const PAGE_TITLE = `LESOTHO ELECTRIFICATION PORTAL`;

export const TEXT_INTRO = `Cet outil web affiche les résultats d'une evaluation nationale des sites adaptés à la generation et au 
traitement de l'hydrogene vert (GH₂) en Algérie.`;

export const TEXT_SIDEBAR = `Sélectionnez un gouvernorat pour continuer.`

export const TEXT_OVERVIEW = {
  SELECT_GOV: "Sélectionnez une province",
  FOCUS_GOV: "Qu'est-ce qu'un gouvernorat de focus ?",
  FOCUS_GOV_DESC: `Les gouvernorats de focus ont été sélectionnés par le ministère 
  de l'industrie, des mines et de l'énergie comme zones de grand intérêt qui s'alignent bien 
  avec la stratégie nationale de l'hydrogène et contiennent des infrastructures clés.
  
  Ces gouvernorats peuvent avoir des données plus complètes intégrées dans l'analyse, 
  et avoir des données supplémentaires précises et récentes recueillies lors de visites sur site 
  pour des emplacements potentiels.`
}

export const TEXT_FILTER = {
  CHANGE_GOV: "Changer de gouvernorat",
  FILTER: "Personnalisez les critères de filtrage",
  SELECT_OPTIONS_INTRO: "Types de terres exclues :",
  //   SELECT_OPTIONS: [« Plans d'eau », “Zones humides”, “Zones habitées”, “Vergers”.],
  SLIDER_INTRO: "Augmentez ou diminuez les zones à considérer :",
  SLIDER_OPTIONS: {building_count: "Building Count", grid_distance: "Distance to Grid", building_density: "Building Density"},
  PASS_FILTER: " zones passant le filtre",
  RANK_AREAS: "Continuez à classer les zones selon leur adéquation",
  VIEW_LAYERS_NON_RASTER: "Infrastructures clé pour le GH₂",
  VIEW_LAYERS_IS_RASTER: "Natural Ressource Potential",
}

export const TEXT_RANK = {
  SELECT_CRITERIA: "Sélectionnez les critères de classement à inclure",
  // RANKING_ARRAY: ["Proximité de la sous-station électrique", "Proximité de la ligne électrique", "Proximité de la centrale électrique", "Proximité de l'autoroute", "Proximité du chemin de fer", "Proximité des ports maritimes", "Proximité du pipeline de gaz", "Potentiel solaire", "Potentiel éolien"],
  RANKING_ARRAY: {powerline: "Proximité de la ligne électrique", seaport: "Proximité des ports maritimes", windDensity: "Potentiel éolien"},
  TABLE_HEADER: {criteria: "Critères", weighting: "Pondération"},
  WEIGHTING_LOOKUP: {m: 'Moyen', l: 'Faible', h: 'Élevé'}
}

export const TEXT_INFO = {
  T_AND_CS: {TITLE: "Conditions générales d'utilisation", BODY_1: ""},
  PARTNERS: {TITLE: "A propos de ce projet", CONTACT: "Contact"},
  DISCLAIMER: {TITLE: "Clause de non-responsabilité", BODY_1: `Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.   

Duis autem vel eum iriure dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi. Lorem ipsum dolor sit amet, `},
TEXT_INFO_CONTACT: 'Pour plus d\'informations, veuillez contacter: ',
TEXT_DOWNLOAD_DATA: 'Télécharger les données',
TEXT_SELECT_LAYER_DOWNLOAD: 'Sélectionnez les couches à télécharger',
}

export const TEXT_DROPDOWN = {
  FOCUS_GOV: "Gouvernorats de focus",
  OTHER_GOV: "Autres gouvernorats",
  SELECT_GOV: "Sélectionnez un Wilaya",
}

export const TEXT_LEGEND = {
  FOCUS_GOV: TEXT_DROPDOWN.FOCUS_GOV,
  OTHER_GOV: TEXT_DROPDOWN.OTHER_GOV,
  HEX_PASS: "La zone passe les critères de filtrage",
  HEX_GR: "Zone la mieux classée",
  HEX_RD: "Zone la moins bien classée",
}

export const TEXT_LAYERS = {
  OPEN_STREET_MAP: "Open Street Map",
  GRID: 'HV and MV gridlines',
  GRID_HV: "High Voltage Grid",
  GRID_LV: "Low Voltage Grid",
  SUBSTATIONS: "Substations",
  POWER_PLANTS: "Power Plants",
  ADMIN: "Administrative Boundaries",
  TOPOGRAPHY: "Topography",
  BLACK_WHITE: "Black and White",
  STREET_MAP: "Street Map",
  SATELLITE: "Satellite",
  SETTLEMENTS_ALL_CENTROIDS: "Settlements",
  SURVEYED_SETTLEMENTS: "Surveyed Settlements",
  MINIGRIDS:"Existing Minigrids",
  WIND: "Mean Wind Speed (m/s)",
  PV: "Solar Potenttial PVOUT (kWh/kWp)",
  NES: "National Electrification Strategy",
}

export const TEXT_HEX_POPUP = 
{title: "Selected hexagon ", 
  table: {
    gov: "Governorat:",
    pop: "Population:",
    coords: "Lat, Long:",
    highway: "Distance de l'autoroute:"
  }}

export const TEXT_PROJECT_PARTNERS = {
  MIME: {TITLE: "Agence d'exécution", NAME: "Ministère de l'industrie, des mines et de l'énergie, MIME", CONTACT_NAME: "Prénom Nom", CONTACT_EMAIL: "test@test.org"},
  GIZ: {TITLE: "Commandé par", NAME: "Deutsche Gesellschaft für Internationale Zusammenarbeit (GIZ) GmbH", CONTACT_NAME: "Prénom Nom", CONTACT_EMAIL: "test@test.org"},
  GOPA: {TITLE: "Chef de file du consortium de consultants", NAME: "GOPA-International Energy Consultants GmbH", CONTACT_NAME: "Prénom Nom", CONTACT_EMAIL: "test@test.org"},
  INT: {TITLE: "Consultants SIG et site web/carte web", NAME: "INTEGRATION Umwelt & Energie GmbH", CONTACT_NAME: "M. Oliver Haas", CONTACT_EMAIL: "ohaas@integration.org"},
}

export const TEXT_SURVEY_SIDEBAR = {
  INTRO: "Sites adaptés à la generation de GH₂",
  SORT_BY_CATEGORY: "Trier par catégorie",
  COORDINATES: "Coordonnées",
  PROVINCE: "Province (Wilaya)",
  AREA: "Superficie total",
  INTRO_DETAILS: "Aperçu du site etudie",
  CLIMATE: "Zone climatique",
  TYPES: {
    WATER: "Eau", 
    WIND: "Vent",
    SOLAR: "Solaire",
    ACCESS: "Accès",
    EXPORT: "Export",
  },
  ZOOM_IN: "Zoomer sur le site",
}

export const TEXT_RATING_ELEMENTS = {
  RATING_WATER: "Eau",
  RATING_WIND: "Vent",
  RATING_SOLAR: "Solaire",
  RATING_ACCESS: "Accès",
  RATING_EXPORT: "Export",  
}

export const TEXT_SURVEY_DATA = {
  HYDROGEN_SUITABILITY_SCORE: "Score d'adéquation à l'hydrogène",
  COORDINATES: "Coordonnées",
  STATE_NAME: "Province Wilaya",
  AREA: "Superficie total",
  CAPACITY_SIZE: "Taille de la capacité",
  PLANT_AREA: "Zone de l'usine",
}

export const TEXT_SURVEY_DATA_DETAILS = {
  DESALINATION_PLANT_PROXIMITY: "Proximité de l'usine de dessalement",
  PIPELINE_PROXIMITY: "Proximité du pipeline",
  HIGHWAY_PROXIMITY: "Proximité de l'autoroute",
  RAILEWAY_PROXIMITY: "Proximité du chemin de fer",
  AIRPORT_PROXIMITY: "Proximité de l'aéroport",
  POWER_LINE_PROXIMITY: "Proximité de la ligne électrique",
  POWER_PLANT_PROXIMITY: "Proximité de la centrale électrique",
  INDUSTRIAL_PROXIMITY: "Proximité des zones industrielles",
  WIND_CAPACITY_FACTOR: "Facteur de capacité éolienne",
}

export const TEXT_DRAWING_TOOL = {
  POLYGON_AREA : "Zone de polygone",
  SQUARE_METER: "m²",
  CLOSE: "Fermer",
}

export const TOOL_TIP_TEXT ={
  building_count: "", 
  grid_distance: "", 
  building_density: "Building Density is the proportion of the building area related to the settlement area. A higher value indicates a higher density of buildings.",
  wind: "Mean Wind Speed on 100 m in m/s. A higher value indicates a higher wind speed. Source: Global Wind Atlas 3.0, https://globalwindatlas.info/.",
  pv: "PVOUT represents the amount of power generated per unit of the installed PV capacity over the long-term, and it is measured in kilowatthours per installed kilowatt-peak of the system capacity (kWh/kWp). Souerce: Global Solar Atlas, https://globalsolaratlas.info/.",
  NES: "The National Electrification Strategy (NES) classification of the settlement into the categories Isolated Customer, Potential Mini-grid Location, and Potential Grid Extension, based on the NES criteria and methodology. Source: World bank and the Lesotho Renewable Energy and Electricity Access Project (LREEAP) Lesotho ",
  POWER_PLANTS: "Commercial Utility Scale Power plats in Lesotho with capacity. Source: Department of Energy, Lesotho",
  SUBSTATIONS: "Relevant substations in Lesotho. Source: Open Street Map",
  MINIGRIDS: "Existing Minigrids in Lesotho with size and number of connections. Source: Department of Energy, Lesotho",
  GRIDLINES: "High Voltage (HV) and Medium Voltage (MV) gridlines in Lesotho. Source: Department of Energy, Lesotho",
  SETTLEMENTS: "Modelled Setllement extends via a satellite based approach. Source: GRID3: https://data.grid3.org/datasets/GRID3::grid3-lso-settlement-extents-v3-0/about",
  SURVEYED_SETTLEMENTS: "Surveyed settlements based on selected survey data collected by GIZ Get.Transform and the Department of Energy, Lesotho",
}
